import {
  ActionIcon,
  Box,
  Button,
  Drawer,
  Group,
  Text,
  List,
  ThemeIcon,
  Avatar,
  Stack,
  Popover,
  Modal,
  Center,
} from "@mantine/core";
import {
  IconMenu2,
  IconUsers,
  IconUserCircle,
  IconBook,
  IconLogout,
  IconCheck,
} from "@tabler/icons";
import React, { useState } from "react";
import { socket } from "../services/socket";
import packageJson from "../../package.json";
import { showNotification } from "@mantine/notifications";

const avatarColors = [
  "cyan",
  "red",
  "violet",
  "blue",
  "green",
  "orange",
  "teal",
  "pink",
  "lime",
  "yellow",
  "gray",
  "dark",
];

const menu = [{ name: "instructions", label: "使用说明", icon: <IconBook /> }];

function ChatHeader({
  room,
  users,
  socket,
  setIsReconnectionModalOpen,
  setMessages,
  setIsLogin,
}) {
  const [isUsersDrawerOpen, setIsUsersDrawerOpen] = useState(false);
  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleMenuItemClick = (item) => {
    setIsModalOpen(true);
  };

  const handleDisconnectClick = () => {
    //setIsMenuDrawerOpen(false);
    //setIsReconnectionModalOpen({ alert: true });
    window.sessionStorage.setItem("login", false); // 2023-03-19 16:52:54 Fix the bug that the user is still login even when user just logout but refreshing the page
    setIsLogin(false);

    //setMessages([]);  // 2022-12-05 11:15:13 Not needed anymore, as login false will unmount the Chat component where the messages state belongs to.
    socket.disconnect();
    showNotification({
      icon: <IconCheck size={20} />,
      title: "你已经离线",
      message:
        "你已经处于离线状态，所有历史消息都已被清空。你可以重新登录开启新的聊天。",
      color: "green",
      autoClose: 5000,
    });
  };

  return (
    <Box>
      <Group
        position='apart'
        // grow
        p='1rem'
        sx={(theme) => ({
          backgroundColor: theme.colors.gray[1],
        })}
      >
        {/* <Popover
          width={200}
          position='bottom'
          withArrow
          shadow='md'
          radius='xl'
        >
          <Popover.Target>
            <ActionIcon>
              <IconMenu2
                size={24}
              />
            </ActionIcon>
          </Popover.Target>
          <Popover.Dropdown
            sx={(theme) => ({
              backgroundColor: theme.colors.orange[3],
            })}
          >
            <Text size='sm'>该功能正在开发中，请稍后查看</Text>
          </Popover.Dropdown>
        </Popover> */}
        <ActionIcon>
          <IconMenu2
            size={24}
            onClick={() => setIsMenuDrawerOpen((prev) => !prev)}
          />
        </ActionIcon>
        <Text>
          聊天室 {room} ({users.length})
        </Text>
        <ActionIcon onClick={() => setIsUsersDrawerOpen((prev) => !prev)}>
          <IconUsers size={24} />
        </ActionIcon>
      </Group>
      <Drawer
        opened={isMenuDrawerOpen}
        position='left'
        title='选项：'
        size='sm'
        padding='xl'
        onClose={() => setIsMenuDrawerOpen(false)}
        styles={(theme) => ({
          drawer: {
            overflow: "auto",
          },
        })}
      >
        <List spacing='xs' size='sm' center>
          {menu.map((item, index) => (
            <List.Item
              key={index}
              icon={
                <ThemeIcon color='lime' size={20} radius='sm'>
                  {item.icon}
                </ThemeIcon>
              }
              onClick={() => handleMenuItemClick(item.name)}
            >
              {item.label}
            </List.Item>
          ))}
        </List>
        <Center
          sx={{
            position: "absolute",
            bottom: "4rem",
            left: "1.5rem",
          }}
          onClick={handleDisconnectClick}
        >
          <ThemeIcon color='gray' size={20}>
            <IconLogout />
          </ThemeIcon>
          <Button variant='subtle' color='gray'>
            退出聊天
          </Button>
        </Center>
        <Box
          sx={{
            position: "absolute",
            bottom: "1rem",
            left: "1.5rem",
          }}
        >
          <Text size='xs'>应用版本: {packageJson?.version}</Text>
        </Box>
      </Drawer>
      <Drawer
        opened={isUsersDrawerOpen}
        position='right'
        title='当前在线用户：'
        size='sm'
        padding='xl'
        onClose={() => setIsUsersDrawerOpen(false)}
        styles={(theme) => ({
          drawer: {
            overflow: "auto",
          },
        })}
      >
        <Stack spacing='md' justify='flex-start'>
          {users.map((user, index) => (
            <Group key={index} position='left' spacing='xl'>
              <Avatar color={avatarColors[index % 10]} radius='xl'>
                {user.name?.[0].toUpperCase()}
              </Avatar>
              <Text>{user.name}</Text>
            </Group>
          ))}
        </Stack>
      </Drawer>
      <Modal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='使用说明：'
        centered
        padding='lg'
      >
        <ol>
          <li>你可以在输入姓名或者昵称以及验证码之后开启群聊。</li>
          <li>
            目前支持发送文字、表情以及图片视频。其中图片限制大小5M以内，视频限制大小10M以内。
          </li>
          <li>支持查看所有在线用户</li>
          <li>
            所有消息都不会在服务器端进行保存，刷新页面或者长时间无消息回复导致处于离线状态都会将本地消息完全清除。
          </li>
        </ol>
      </Modal>
    </Box>
  );
}

export default ChatHeader;
